// This form is used in all login help options other than "forgot login Id"

import * as React from "react";
import InputField from "../../generic/inputField";
import { emailRegex, pan, alphaNumExp } from "../../utils/regex";
import EdButton from "../../generic/edButton";
import RadioButton from "../../generic/radioButton";
import "../../../assets/scss/Login/login/generic/loginInput.scss";
import "../../../assets/scss/Login/login/forms/forgotLoginIdForm.scss";

import { IListObj } from "../../types/genericTypes";
import LoginErrMsg from "../generic/loginErrMsg";
import { AUnblockAccount } from "../../../services/login/loginApiService";
import loginURLConfig from "../../../config/login/loginURLConfig";

export interface IUnblockAccountFormProps {
  onSuccess: (msg: string) => void; // function to be called on the success of called apis
}

// form fields
export interface IUnblockAccountFormFields {
  pan: string;
  email: string;
  loginId: string;
  accTyp?: string;
}

const UnblockAccountForm: React.FC<IUnblockAccountFormProps> = (props) => {
  // used to store the entered values in form
  const [values, setValues] = React.useState<IUnblockAccountFormFields>( {pan: "", email: "", loginId: "", accTyp: "EQ"} );

  // used to store the field wise errors
  const [errors, setErrors] = React.useState<{
    [key in keyof IUnblockAccountFormFields]?: string;
  }>({
    pan: undefined,
    email: undefined,
    loginId: undefined,
  });

  // used to store the error message that comes from api
  const [errorMsg, setErrorMsg] = React.useState("");

  // used to store if the form is submitted or not
  const [submitted, setSubmitted] = React.useState(false);

  // to check the route

  const accTyp: Array<IListObj> = [
    { value: "EQ", display: "Equity" },
    { value: "CO", display: "Commodity" },
  ];

  function handleSubmit(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    setSubmitted(true);
    AUnblockAccount(apiRes, values);
  }

  function apiRes(res: any) {
    if (res.data) {
      // if success, then call the onSuccess function in prop
      props.onSuccess(res.data.msg);
    } else if (res.error) {
      // else enable form again

      if (res.error.errCd === "ELGH0001") {
        setSubmitted(false);
        // show account type radio
        setValues({ ...values, accTyp: "EQ" });
      } else {
        // hide account type radio and error msg block
        // const { pan, email, loginId, accTyp } = values;
        // setValues({ pan, email, loginId, accTyp });
        setErrorMsg(res.error.errMsg);
      }
    }
  }

  function onChange(key: keyof IUnblockAccountFormFields, value: string) {
    if ((key === "loginId" || key === "pan") && !alphaNumExp.test(value)) {
      value = values[key];
    }
    if(key =="accTyp"){
			setErrors({...errors, pan: "", email: "", loginId: ""});
			setValues({ pan: "", email: "", loginId: "", accTyp: value});
		}else{ 
			setErrors({ ...errors, [key]: "" });
			setValues({ ...values, [key]: value });
		}
    // onchange of any field remove both type of errors
    setErrorMsg("");
    setSubmitted(false);
    return value;
  }

  return (
    <form className="login_form">
      <div className="same_acc">
        {/* <p className="inp_lbl mg-b15">Select Account type :</p>
        <ul className="same_acc_radio mg-b45">
          <li className="list_Item">
            {accTyp.map((typ) => (
              <RadioButton
                key={typ.value}
                list={typ}
                name={"sameAcc"}
                selected={values.accTyp}
                onChange={() => onChange("accTyp", typ.value as string)}
              />
            ))}
          </li>
        </ul> */}
      </div>

      <label htmlFor="login-id-input" className="inp_lbl mg-b5 ib">Login ID</label>
      <InputField
        id="login-id-input"
        defaultValue = {values.loginId}
        onChange={(loginId) => onChange("loginId", loginId)}
        onBlur={(error) => {
          setErrors({
            ...errors,
            loginId: error.required ? "Field is required" : "",
          });
        }}
        maxLength={24}
        className="login_inp mg-b40"
        placeholder="Eg:5678987"
        required
        errorText={errors.loginId}
      />
      {(values.accTyp =="EQ" || !loginURLConfig.CommKambala) && (<>
      <label htmlFor="email-input" className="inp_lbl mg-b5 ib">Email ID</label>
      <InputField
        id="email-input"
        defaultValue = {values.email}
        pattern={emailRegex}
        required
        onChange={(email) => onChange("email", email)}
        onBlur={(error) =>
          setErrors({
            ...errors,
            email: error.pattern ? "" : "Please enter a valid email address",
          })
        }
        className="login_inp mg-b40"
        placeholder="Eg: sarveshpali@gmail.com"
        errorText={errors.email}
      />
      </>)}

      <label htmlFor="pan-input" className="inp_lbl mg-b5 ib">PAN No.</label>
      <InputField
        id="pan-input"
        defaultValue = {values.pan}
        onChange={(pan) => onChange("pan", pan)}
        onBlur={(error) =>
          setErrors({
            ...errors,
            pan: error.pattern ? "" : "Please enter a valid PAN",
          })
        }
        className="login_inp mg-b40"
        placeholder="Eg: JUKL5678987"
        helpTextColor="blue"
        required
        pattern={pan}
        errorText={errors.pan}
        maxLength={10}
      />

      {/* This select account type block will only show if "ELGH0001" error comes in response to api */}
      {/* {values.accTyp && !loginURLConfig.CommKambala &&(
        <div className="same_acc">
          <p className="inp_lbl mg-b15">Select Account type :</p>
          <ul className="same_acc_radio mg-b45">
            <li className="list_Item">
              {accTyp.map((typ) => (
                <RadioButton
                  key={typ.value}
                  list={typ}
                  name={"sameAcc"}
                  selected={values.accTyp}
                  onChange={() => onChange("accTyp", typ.value as string)}
                />
              ))}
            </li>
          </ul>
        </div>
      )} */}

      {/* Show error if any */}
      {errorMsg && <LoginErrMsg className="mg-b40">{errorMsg}</LoginErrMsg>}

      <EdButton
        value={"Unblock Account"}
        btnTyp="primary"
        className="submit_btn"
        // Disable if there is even one error or if any field is empty or if form is submitted
        disabled={
          Object.values(errors).some((error) => error) ||
          ((values.accTyp =="EQ"|| !loginURLConfig.CommKambala) ? (Object.values(values).some((value) => !value)) : (!values.loginId || !values.pan)) ||
          submitted  
        }
        onClick={handleSubmit}
      />
    </form>
  );
};

export default UnblockAccountForm;